import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useParams } from 'react-router-dom';
import chapterApiProvider from '../apiProvider/chapterApi';
import { IMAGE_BASE_URL } from '../network/apiClient';
import { toast } from 'react-toastify';

const users = [
    {
        id: 1,
        date: '2025-05-12',
        from: 'Elankathir',
        to: 'Kesavan',
        where: 'Vadapalani',
        discuss: 'About Business Growth',
        chapter: 'GRIP Aram',
        photo: '/assets/images/avatar/avatar-group1.png',
    },
    {
        id: 2,
        date: '2025-05-03',
        from: 'Aravind',
        to: 'PanchaiNadhan',
        where: 'Nungambakkam',
        discuss: 'About Business Strategies',
        chapter: 'GRIP Virutcham',
        photo: '/assets/images/avatar/avatar-group1.png',
    },
    {
        id: 3,
        date: '2025-05-14',
        from: 'Saravanan',
        to: 'Bala',
        where: 'T Nagar',
        discuss: 'Discussed referrals',
        chapter: 'GRIP Blossoms',
        photo: '/assets/images/avatar/avatar-group1.png',
    },
    {
        id: 4,
        date: '2025-05-15',
        from: 'Naveen',
        to: 'Arjun',
        where: 'Anna Nagar',
        discuss: 'Marketing ideas exchange',
        chapter: 'GRIP Bloom',
        photo: '/assets/images/avatar/avatar-group1.png',
    },
    {
        id: 5,
        date: '2025-05-16',
        from: 'Karthik',
        to: 'Sundar',
        where: 'Kodambakkam',
        discuss: 'Business opportunity talk',
        chapter: 'GRIP Rise',
        photo: '/assets/images/avatar/avatar-group1.png',
    },
];

const UsersListLayer = () => {
    const [showModal, setShowModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');

    const handleShowImage = (image) => {
        setSelectedImage(image);
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
        setSelectedImage('');
    };
    const [chapterMembers, setchapterMembers] = useState([])
    const { id } = useParams();
    const fetchChapters = async (id) => {
        try {
            const response = await chapterApiProvider.onetooneSlipListMember(id);
            console.log(response, "responce-chapterApiProvider");
            setchapterMembers(response?.response?.data)

        } catch (error) {
            console.error("Error fetching chapters:", error);
            // Handle the error (e.g., show error message to user)
        }
    };
    useEffect(() => {
        fetchChapters(id);
    }, [id]);
    const handleStatusChange = async (status, recordId) => {
        console.log(status, "status", recordId, "recordId")
        if (!status) return;
        try {
            let input = {   
                status: status,
                id: recordId,
                formName: "onetoone"
            }
            const response = await chapterApiProvider.changeStatus(input);
            console.log(response, "responce-chapterApiProvider");
            // Handle success
            if (response) {
                toast("status updated successfully")
                fetchChapters(id);
            }
            else {
                toast("failed to update status")
                fetchChapters(id);
            }

        } catch (error) {
            console.error('Error updating status:', error);
            alert('Failed to update status');
        } finally {
        }
    };
    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                <div className="d-flex align-items-center flex-wrap gap-3">
                    {/* <form className="navbar-search">
                        <input
                            type="text"
                            className="bg-base h-40-px w-auto"
                            name="search"
                            placeholder="Search"
                        />
                        <Icon icon="ion:search-outline" className="icon" />
                    </form> */}


                </div>

                <div className="d-flex align-items-center flex-wrap gap-3">

                    {/* <select className="form-select form-select-sm w-auto" defaultValue="Select Number">
                        <option value="Select Number" disabled>
                            Select Chapter
                        </option>
                        <option value="10">GRIP Aram</option>
                        <option value="15">GRIP Virutcham</option>
                        <option value="20">GRIP Madhuram</option>
                        <option value="20">GRIP Kireedam</option>
                        <option value="20">GRIP Amudham</option>

                    </select> */}

                    <select className="form-select form-select-sm w-auto" defaultValue="Select Number">
                        <option value="Select Number" >
                            This Week
                        </option>
                        <option value="10">This Month</option>
                        <option value="15">Last Week</option>
                        <option value="20">Last Month</option>
                        <option value="20">This Term</option>


                    </select>

                </div>
            </div>
            <div className="card-body p-24">
                <div className="table-responsive scroll-sm">
                    <table className="table bordered-table sm-table mb-0">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Date</th>
                                <th>From</th>
                                <th>121 To</th>
                                <th>Where</th>
                                <th>Discussion</th>
                                <th>Chapter Name</th>
                                <th className="text-center">Photo (Photo View)</th>
                                <th className="text-center">Approve</th>
                            </tr>
                        </thead>
                        <tbody>
                            {chapterMembers?.records?.map((item, index) => (
                                <tr key={item._id}>
                                    <td>{index + 1}.</td>
                                    <td>{new Date(item.date).toLocaleDateString('en-IN')}</td>
                                    <td>
                                        {item.fromMember?.name || 'N/A'}
                                        {item.fromMember?.mobile && <small className="d-block text-muted">{item.fromMember.mobile}</small>}
                                    </td>
                                    <td>
                                        <span className="text-md mb-0 fw-normal text-secondary-light">
                                            {item.toMember?.name || 'N/A'}
                                            {item.toMember?.mobile && <small className="d-block text-muted">{item.toMember.mobile}</small>}
                                        </span>
                                    </td>
                                    <td>{item.whereDidYouMeet || '-'}</td>
                                    <td>{item.discuss || '-'}</td>
                                    <td>
                                        {chapterMembers.chapter?.chapterName || '-'}
                                    </td>
                                    <td className="text-center">
                                        {item.images?.length > 0 ? (
                                            <button
                                                className="btn btn-sm btn-outline-info"
                                                onClick={() => handleShowImage(`${IMAGE_BASE_URL}/${item.images[0].docPath}/${item.images[0].docName}`)}
                                            >
                                                View
                                            </button>
                                        ) : (
                                            <span className="text-muted">No Image</span>
                                        )}
                                    </td>
                                    <td className="text-center">
                                        <select
                                            className="form-select form-select-sm w-auto"
                                            onChange={(e) => handleStatusChange(e.target.value, item._id)}
                                            value={item.status || ""}  // Set default to empty or current status
                                        >
                                            <option value="" disabled>Select Action</option>
                                            <option value="active">Active</option>
                                                <option value="decline">decline</option>
                                        </select>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Image Modal */}
                <Modal show={showModal} onHide={handleClose} centered>
                    <Modal.Body className="text-center">
                        <img src={selectedImage} alt="Profile" className="img-fluid" />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
};

export default UsersListLayer;
